<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="操作用户账号">
              <j-input placeholder="请输入操作用户账号" v-model="queryParam.userid"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="操作用户名称">
              <j-input placeholder="请输入操作用户名称" v-model="queryParam.username"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="问题">
              <j-input placeholder="请输入问题" v-model="queryParam.query"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="回答">
              <j-input placeholder="请输入回答" v-model="queryParam.answer"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24">
            <a-form-item label="创建日期">
              <j-date placeholder="请选择开始日期" class="query-group-cust" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" v-model="queryParam.createTime_begin"></j-date>
              <span class="query-group-split-cust"></span>
              <j-date placeholder="请选择结束日期" class="query-group-cust" :show-time="true" date-format="YYYY-MM-DD HH:mm:ss" v-model="queryParam.createTime_end"></j-date>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
<!--              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="download" @click="handleExportXls('emp_aiagent_log')">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <template v-if="record.userid">
            <a-divider type="vertical" />
            <a @click="openChatListModal(record)">对话列表</a>
          </template>
          <template v-if="record.conversationId">
            <a-divider type="vertical" />
            <a @click="openChatDetailModal(record)">对话详情</a>
          </template>
        </span>

        <template slot="querySlot" slot-scope="text, record, index">
          <a-tooltip :title="record.query" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>30?text.substr(0,30)+"...":text)}}</span>
          </a-tooltip>
        </template>
        <template slot="answerSlot" slot-scope="text, record, index">
          <a-tooltip :title="record.answer" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>50?text.substr(0,50)+"...":text)}}</span>
          </a-tooltip>
        </template>
      </a-table>
    </div>

    <emp-aiagent-log-modal ref="modalForm" @ok="modalFormOk"></emp-aiagent-log-modal>
    <!-- 对话列表弹窗 -->
    <a-modal
      title="对话列表"
      :visible="chatListModalVisible"
      :footer="null"
      width="80%"
      zIndex="1000"
      @cancel="closeChatListModal"
    >
      <chat-list-modal
        v-if="chatListModalVisible"
        :visible="chatListModalVisible"
        :user="currentRecord && currentRecord.userid"
        @close="closeChatListModal"
        @view-conversation="handleViewConversation"
      />
    </a-modal>
    <!-- 对话详情弹窗 -->
    <a-modal
      title="对话详情"
      :visible="chatDetailModalVisible"
      :footer="null"
      width="50%"
      zIndex="1001"
      @cancel="closeChatDetailModal"
    >
      <chat-detail-modal
        v-if="chatDetailModalVisible"
        :visible="chatDetailModalVisible"
        :conversationId="currentRecord && currentRecord.conversationId"
        :user="currentRecord && currentRecord.userid"
        @close="closeChatDetailModal"
      />
    </a-modal>

  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpAiagentLogModal from './modules/EmpAiagentLogModal'
  import ChatListModal from './modules/ChatListModal';
  import ChatDetailModal from './modules/ChatDetailModal';

  export default {
    name: 'EmpAiagentLogList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpAiagentLogModal,
      ChatListModal,
      ChatDetailModal
    },
    data () {
      return {
        description: 'emp_aiagent_log管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'api类型',
            align:"center",
            dataIndex: 'apiType'
          },
          {
            title:'操作用户账号',
            align:"center",
            dataIndex: 'userid'
          },
          {
            title:'操作用户名称',
            align:"center",
            dataIndex: 'username'
          },
          /*{
            title:'请求java方法',
            align:"center",
            dataIndex: 'method'
          },*/
          /*{
            title:'content',
            align:"center",
            dataIndex: 'content'
          },*/
          /*{
            title:'category',
            align:"center",
            dataIndex: 'category'
          },*/
          /*{
            title:'请求路径',
            align:"center",
            dataIndex: 'requestUrl'
          },*/
          {
            title:'问题',
            align:"center",
            dataIndex: 'query',
            scopedSlots: {customRender: "querySlot"},
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          /*{
            title:'请求类型',
            align:"center",
            dataIndex: 'requestType'
          },*/
          {
            title:'耗时',
            align:"center",
            dataIndex: 'costTime'
          },
          {
            title:'回答',
            align:"center",
            dataIndex: 'answer',
            scopedSlots: {customRender: "answerSlot"},
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          /*{
            title:'删除标准',
            align:"center",
            dataIndex: 'delFlag'
          },*/
          {
            title: "创建时间",
            align: "center",
            width: 150,
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/hhemp/aiagent/empaiagentlogs",
          delete: "/hhemp/aiagent/empaiagentlog",
          deleteBatch: "/hhemp/aiagent/empaiagentlog/batch",
          exportXlsUrl: "/hhemp/aiagent/export-xls",
          importExcelUrl: "hhemp/aiagent/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
        chatListModalVisible: false,
        chatDetailModalVisible: false,
        currentRecord: null
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      openChatListModal(record) {
        this.currentRecord = record;
        this.chatListModalVisible = true;
      },
      openChatDetailModal(record) {
        if (!record.conversationId) return;
        this.currentRecord = record;
        this.chatDetailModalVisible = true;
      },
      closeChatListModal() {
        this.chatListModalVisible = false;
        this.currentRecord = null;
      },
      closeChatDetailModal() {
        this.chatDetailModalVisible = false;
        this.currentRecord = null;
      },
      handleViewConversation(payload) {
        // 从对话列表跳转到对话详情
        /*this.chatListModalVisible = false;
        this.$nextTick(() => {
          // 更新当前记录的 conversationId
          if (this.currentRecord) {
            this.currentRecord.conversationId = conversationId;
          }
          this.chatDetailModalVisible = true;
        });*/
        // 从对话列表跳转到对话详情 - 保持列表弹窗开启
        // 创建一个新的记录对象用于对话详情
        console.log('=== Debug Info ===');
        console.log('Payload received:', payload);
        console.log('Current record before:', this.currentRecord);
        console.log('Current record userid:', this.currentRecord && this.currentRecord.userid);

        const detailRecord = {
          ...this.currentRecord,
          conversationId: payload.conversationId,
          userid: payload.user || (this.currentRecord && this.currentRecord.userid)
        };

        console.log('Detail record after:', detailRecord);
        console.log('Detail record userid:', detailRecord.userid);
        console.log('=== End Debug ===');

        // 打开对话详情弹窗，但不关闭列表弹窗
        this.chatDetailModalVisible = true;
        this.currentRecord = detailRecord;
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
